import { colors } from 'framework/theme/constants/colors';

import { ChipDimensions, ChipOptions } from './types';

export function drawLine(
  ctx: CanvasRenderingContext2D,
  start_x: number,
  start_y: number,
  end_x: number,
  end_y: number,
  color: string
): void {
  ctx.save();

  ctx.beginPath();
  ctx.setLineDash([5, 5]);
  ctx.lineWidth = 1;
  ctx.strokeStyle = color;

  ctx.moveTo(start_x, start_y);
  ctx.lineTo(end_x, end_y);
  ctx.stroke();

  ctx.restore();
}

export function drawChip(
  ctx: CanvasRenderingContext2D,
  value: string,
  x: number,
  y: number,
  center: boolean,
  options: ChipOptions
): ChipDimensions {
  const { background, border } = options;

  ctx.save();

  ctx.font = `12px Roboto`;

  const bounds = ctx.measureText(value);

  const padding = 4;
  const border_width = 1;
  const border_radius = 4;
  const width = bounds.width + padding * 2;
  const height = 22;

  let chipX = center ? x - width / 2 : x;
  // Ensure the chip does not overflow the chart's right edge
  if (chipX + width > ctx.canvas.offsetWidth) {
    chipX = ctx.canvas.offsetWidth - width;
  }

  // Draw background
  ctx.fillStyle = background;
  ctx.beginPath();
  ctx.setLineDash([0, 0]);
  ctx.roundRect(chipX, y - height / 2, width, height, border_radius);
  ctx.fill();

  ctx.strokeStyle = border;
  ctx.lineWidth = border_width;
  ctx.stroke();

  // Draw text
  ctx.fillStyle = colors.light[1];
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(value, chipX + width / 2, y + 1);

  ctx.restore();

  return { width, height };
}
